export default {
  title_1: '¿Por qué necesitas una billetera de hardware?',
  desc_1_1:
    'Como Web3 se construye sobre contratos inteligentes, introduce riesgos para muchos usuarios de blockchain.',
  desc_1_2:
    'Al crear una billetera o firmar transacciones, tu teléfono u ordenador pueden enfrentar riesgos como intrusiones, malware o monitoreo del portapapeles. Un dispositivo de seguridad dedicado te protege mejor en Web3.',
  desc_1_3: 'En este punto, una billetera de hardware es una de las mejores opciones.',

  title_2: '¿Por qué es segura una billetera de hardware?',
  desc_2_1: 'Chips de seguridad',
  desc_2_2: 'Ayudan a crear la billetera',
  desc_2_3: 'Almacenamiento seguro',
  desc_2_4: 'Gestión y custodia de claves fuera de línea',
  desc_2_5: 'Evita hackeos',
  desc_2_6: 'Aléjate de las estafas',

  title_3: '¿Por qué KeyPal?',
  desc_3_1: 'Doble chip',
  desc_3_2:
    'KeyPal adopta un diseño de seguridad de doble chip: MCU anti-manipulación y chip de seguridad SE.',
  desc_3_3: 'Certificación anti-falsificación',
  desc_3_4:
    'Cada dispositivo KeyPal posee un certificado de identidad único y un número de serie grabado con láser en la parte trasera, usados para la verificación anti-falsificación en línea.',
  desc_3_5: 'Evita transmitir datos sensibles',
  desc_3_6:
    'KeyPal se comunica con la app mediante Bluetooth de doble canal y USB. Durante la comunicación por Bluetooth, la capa de enlace no transmite datos sensibles, evitando su interceptación.',
  desc_3_7: 'Código PIN',
  desc_3_8:
    'Al crear o restaurar una billetera debes configurar un PIN de arranque y, en cada encendido, introducirlo correctamente. Si se introduce mal varias veces seguidas, el dispositivo se restablece a valores de fábrica y borra todos los datos, para impedir el acceso en casos de error, pérdida o robo.',
  desc_3_9:
    'KeyPal sigue los estándares BIP32/BIP39/BIP44 y ofrece un entorno seguro fuera de línea para generar, gestionar y proteger las frases mnemotécnicas. Con Bluetooth cifrado, protección por PIN y pantalla a color de 2,0", cada transacción firmada se muestra para que «FIRMES LO QUE VES», evitando manipulaciones y ataques de intermediario (MITM).',

  SE_desc_1: '1. Generador de números aleatorios verdadero integrado',
  SE_desc_2: '2. Múltiples almacenamientos seguros',
  SE_desc_3: '3. La semilla nunca sale del chip',
  SE_desc_4: '4. Resiste ataques de fuerza bruta y lecturas externas',
  MCU_desc_1: '1. Cifrado de nivel bancario',
  MCU_desc_2: '2. Seguridad del sistema y detección de manipulación',
  MCU_desc_3: '3. Resistencia a ataques externos e inyección de código',
};
